import React, { useEffect, useState } from "react";

import { usePage } from "utils/fetchData";
import { Modal } from "@mm/ui";
import { Loading } from "components/molecules";
import { ProtectedForm } from "components/organisms";

import HomepageComp from "./HomePageComponent";
import LandingPageComp from "./LandingPageComponent";
import { HandraiserPage } from "../HandraiserPage";
import { HandraiserCode } from "../HandraiserCode";

import { SamsungParadigmPage } from "../SamsungParadigmPage";
import { KarnevalAktionsPage } from "../KarnevalAktionsPage";

const Homepage = () => {
  const { data: page } = usePage();
  const [isPageProtected, setIsPageProtected] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [isMounted, setIsMounted] = useState(true);
  const [voucherCode, setVoucherCode] = useState("");

  useEffect(() => {
    if (page) {
      const { isProtected: isProtectedFromPage } = page;
      // Check if the component is still mounted before updating the state
      if (isMounted) {
        setIsPageProtected(isProtectedFromPage);
      }
    }
  }, [page]);

  useEffect(() => {
    // Check if the component is still mounted before updating the state
    if (isMounted) {
      setModalStatus(isPageProtected);
    }
  }, [isPageProtected]);

  // Cleanup function to set isMounted to false when the component is unmounted
  useEffect(() => {
    return () => {
      setIsMounted(false);
    };
  }, []);

  if (!page || isPageProtected) {
    return (
      <>
        <Modal
          closable={false}
          dynamicHeight
          isInitialOpen={modalStatus}
          onRequestClose={() => {
            setModalStatus(true);
          }}
        >
          <ProtectedForm
            headline="Exklusive Vorbesteller-Angebote"
            label="Aktionscode"
            buttonText="Jetzt authentifizieren"
            disclaimerText="Gib hier deinen persönlichen Aktionscode ein und erhalte Zugang zu unseren exklusiven Vorbesteller-Angeboten. Deinen Aktionscode haben wir dir per Mail geschickt."
            errorMessage="Dein Code kann nicht verifiziert werden"
            setIsPageProtected={(e) => setIsPageProtected(e)}
            setVoucherCode={(e) => setVoucherCode(e)}
          />
        </Modal>
        <Loading variant="home" />
      </>
    );
  }

  if (page.url == "karneval-gewinnspiel") {
    return <KarnevalAktionsPage page={page} voucherCode={voucherCode} />;
  }

  if (page.url == "samsung-paradigm-gewinnspiel") {
    return <SamsungParadigmPage page={page} voucherCode={voucherCode} />;
  }

  if (page.url == "samsung-anmeldung") {
    return <HandraiserPage page={page} voucherCode={voucherCode} />;
  }

  if (page.url == "samsung-neuheitcode") {
    return <HandraiserCode page={page} voucherCode={voucherCode} />;
  }

  if (page.url) {
    return <LandingPageComp page={page} voucherCode={voucherCode} />;
  }

  return <HomepageComp page={page} />;
};

Homepage.propTypes = {};

Homepage.defaultProps = {};

export default Homepage;
